<template>
  <!-- banner -->
  <div class="banner">
    <div class="container">
      <div class="row justify-content-between">
        <div class="col-10 offset-1 col-lg-4 offset-lg-8 text-center center">
          <h3>Vo/2347</h3>
          <h1>Revive Foundation Malta</h1>
        </div>
      </div>
    </div>
  </div>

  <TheMissionVision />
  <TheObjective />
  <div style="background: linear-gradient(220deg, rgba(178, 199, 91, 1) 5%, rgba(0, 83, 1, 0.7) 100%)">
    <TheProjects :max-projects="3" />
  </div>
  <TheNews  :max-news="3"/>

  <!-- Contact -->
  <div class="contact" v-if="false">
      <div class="row">
        <div class="col-12 col-lg-6 contact-image">
        </div>
        <div class="col-12 col-lg-6 mb-5">
          <TheContact />
        </div>
      </div>
  </div>
</template>

<script setup>
import TheObjective from '@/components/TheObjective.vue'
import TheMissionVision from '@/components/TheMissionVision.vue'
import TheContact from '@/components/TheContact.vue'
import TheNews from '@/components/TheNews.vue';
import TheProjects from '@/components/TheProjects.vue';
import { useSEO } from '@/composables/useSEO'

const { setPageSEO } = useSEO()

// Set SEO for home page
setPageSEO(
  'Revive Foundation Malta | Empowering Change, Supporting Communities',
  'Join Revive in making a difference. Learn how you can help create lasting change through volunteerism and support the Empowerment for All.'
)
</script>
<style lang="scss">
  @import "@/styles/_variables.scss";

  .banner {
    background: linear-gradient(75deg, rgba(0, 0, 0, 0) 45%, rgba(0, 0, 0, 0.7) 70%), url('@/assets/banner.jpg');
    filter: brightness(1);
    height: 60vh;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    color: white;
    text-shadow: var(--text-shadow);

    @media screen and (max-width: 960px) {
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 45%, rgba(1, 1, 1, 0.7) 70%), url('@/assets/banner.jpg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      height: 45vh;
    }
  }

  .contact-image {
    background: linear-gradient(90deg, rgba(0, 0, 0, 0) 45%, rgba(1, 1, 1, 0.7) 70%), url('@/assets/member.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 75vh;

    @media screen and (max-width: 960px) {
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 45%, rgba(1, 1, 1, 0.7) 70%), url('@/assets/member.jpg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      height: 45vh;
    }
  }
</style>